import { createActions } from '../../../context';
import * as actions from './consumer-list.actions';

export const consumerList = store => ({
    items: [],
    actions: createActions(actions)(store)
});